// Module
var code = `<section class="page-body default-content">

  <h2>Links</h2>
  <p>
    Links are essential for navigation and action. SpyneJS provides consistent styles
    for anchors (<code>&lt;a&gt;</code>) including hover, focus, and visited states.
    They inherit from the design system’s theme tokens, ensuring color contrast and accessibility.
  </p>

  <!-- Default Link -->
  <h3>Default Link</h3>
  <p>By default, all <code>&lt;a&gt;</code> elements are styled with <code>--text-link</code> color.</p>
  <div class="link-examples">
    <a href="#">Default Link</a>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;a href="#"&gt;Default Link&lt;/a&gt;
    </code></pre>
  </div>

  <!-- With Hover -->
  <h3>Hover State</h3>
  <p>
    Links darken slightly on hover using <code>color-mix()</code> with the paper background,
    making the interaction clear without breaking theme consistency.
  </p>
  <div class="link-examples">
    <a href="#" class="demo-hover">Hover me</a>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;a href="#"&gt;Hover me&lt;/a&gt;
    </code></pre>
  </div>

  <!-- Focus -->
  <h3>Focus Ring</h3>
  <p>
    On focus, links receive a visible focus ring using a transparent
    <code>box-shadow</code> around <code>--text-link</code>.
    This ensures accessibility for keyboard users.
  </p>
  <div class="link-examples">
    <a href="#" class="demo-focus">Focus me (tab to focus)</a>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;a href="#"&gt;Focus me&lt;/a&gt;
    </code></pre>
  </div>

  <!-- Visited -->
  <h3>Visited State</h3>
  <p>
    Visited links use a slightly darker tone for distinction, ensuring
    users can differentiate between visited and unvisited destinations.
  </p>
  <div class="link-examples">
    <a href="https://example.com" target="_blank">Visited Link Example</a>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;a href="https://example.com" target="_blank"&gt;Visited Link Example&lt;/a&gt;
    </code></pre>
  </div>

  <!-- Prefixed Links -->
  <h3>Prefixed Links (Plugins)</h3>
  <p>
    Plugins can use prefixed link classes like <code>.devtool-link</code>
    to avoid collisions with the host application. These inherit
    from either the host’s CSS variables or plugin-specific prefixed vars.
  </p>
  <div class="link-examples">
    <a href="#" class="devtool-link">Prefixed Devtool Link</a>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;a href="#" class="devtool-link"&gt;Prefixed Devtool Link&lt;/a&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Ensure link text is descriptive (avoid “click here”).</li>
    <li>Maintain contrast ratio of at least 4.5:1 against background.</li>
    <li>Always provide <code>href</code> attributes (use <code>button</code> if no navigation).</li>
    <li>Keyboard focus styles are included by default to support accessibility.</li>
  </ul>

</section>
`;
// Exports
module.exports = code;